import CloseIcon from '@material-ui/icons/Close'
import { CSSProperties, FC, ReactNode, useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import styled from 'styled-components'

type ModalProps = {
  id: string,
  children: ReactNode,
  styleOverlay?: CSSProperties,
  styleContentModal?: CSSProperties
}
type CloseButtonProps = {
  style?: CSSProperties,
  onClick?: (e: any) => void
}

type UseModalReturn = {
  closeModal: () => void,
  openModal: (idModal: string) => void,
  Modal: FC<ModalProps>,
  ModalCloseButton: FC<CloseButtonProps>,
  isActiveModal: (idModal: string) => boolean
}

const useModal = (): UseModalReturn => {
  const [activeModal, setActiveModal] = useState<string>()

  const CloseButton: FC<CloseButtonProps> = ({ style, onClick }) => {
    const onClose = (e: any) => {
      setActiveModal(undefined)
      onClick && onClick(e)
    }
    return (
      <CloseIcon className='close-modal' style={{ cursor: 'pointer', fontSize: '20px', ...style }} onClick={onClose}></CloseIcon>
    )
  }

  const closeModal = () => {
    setActiveModal(undefined)
  }

  const Modal: FC<ModalProps> = ({ id, children, styleOverlay, styleContentModal }) => {
    return (
      <ModalContainer id={id} style={styleOverlay} isOpen={activeModal === id}>
        <OutsideClickHandler onOutsideClick={closeModal}>
          <PopUp style={styleContentModal}>
            {children}
          </PopUp>
        </OutsideClickHandler>
      </ModalContainer>
    )
  }

  return {
    closeModal,
    openModal: (idModal: string) => {
      setActiveModal(idModal)
    },
    Modal: Modal,
    ModalCloseButton: CloseButton,
    isActiveModal: (idModal: string) => {
      return activeModal === idModal
    }
  }
}

export default useModal

const ModalContainer = styled.div<{ isOpen: boolean }>`
  position: absolute;
	top: 0;
	bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  background: rgba(0,0,0,0.5);
	transition: opacity 200ms;
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
	opacity: ${props => props.isOpen ? '1' : '0'};
`
const PopUp = styled.div`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
	padding: 20px;
	background: #fff;
	border: 1px solid #666;
	width: 400px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
	position: absolute;
`